export default "__VITE_ASSET__B_9_yzsF__"